export const IS_BROWSER = typeof window !== 'undefined';
export const IS_PRODUCTION =
    process.env.NODE_ENV === 'production' &&
    process.env.GATSBY_NODE_ENV !== 'development';
export const CRYPTO_KEY = process.env.GATSBY_CRYPTO_KEY || '';
